import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import DoNotDisturbOffIcon from '@mui/icons-material/DoNotDisturbOff';
import TableContainer from '@mui/material/TableContainer';
import { API_URL } from '../../Constants';
import SideDrawer from '../header/SideDrawer';
import Modal from '../modal/Modal';
import { Alert, Backdrop, CircularProgress, FormControl, InputLabel, MenuItem, Select, Snackbar, TextField } from '@mui/material';
import { axiosClient } from '../AxiosClient';

let apiUrl = API_URL;


const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    color: '#FFFFFF',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

var formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const dateFormater = (dateToFormat) => {
    if (dateToFormat != '' && dateToFormat != undefined) {
        let justDate = dateToFormat.toString().split("T")[0].split('-')
        return justDate[2] + "-" + justDate[1] + "-" + justDate[0]
    }
    else {
        return "Fecha Invalida"
    }
};

function render(status) {
    let elemento = null;
  
    if (status == 'PENDING') {
        elemento = <HourglassBottomIcon></HourglassBottomIcon>;
    } else if (status == 'PAID') {
      elemento = <CheckCircleOutlineIcon></CheckCircleOutlineIcon>;
    } else if (status == 'PARTIALLY_PAID') {
      elemento = <DoNotDisturbOffIcon></DoNotDisturbOffIcon>;
    } else {

    }
  
    return (
      <div>
        {elemento}
      </div>
    );
  }

  const quotas = Array.from(Array(24), (_, index) => index + 1);

export default function CobranzaDetail() {

    const [data, setData] = useState([]);
    const [clientName, setClientName] = useState("");
    const [clientLastName, setClientLastName] = useState("");
    const [creditOldId, setCreditOldId] = useState("");
    const [isModal, setIsModal] = useState(false);
    const [isButton, setIsButton] = useState(false);
    const [quota, setQuota] = useState();
    const [dayNumber, setDayNumber] = useState();
    const [quotasPending, setQuotasPending] = useState();
    const [isBackdrop, setIsBackdrop] = useState(false);
    const [isSnackbar, setIsSnackbar] = useState(false);
    const [newQuota, setNewQuota] = useState();
    const [severity, setSeverity] = useState("");
    const [message, setMessage] = useState("");
    const [value, setValue] = useState(0);
    const [balanceCredit, setBalanceCredit] = useState(0);
    const [numberQuotas, setNumberQuotas] = useState();
    const [parameters, setParameters] = useState();
    const [creditRestructuring, setCreditRestructuring] = useState();

    const handleModal = () => {
        setIsModal(!isModal)
        
    }

    const handleButton = () => {
        setIsButton(!isButton)
        setDayNumber()
    }

    const generateQuotas = (quotaNumber) => {
        return Array.from({length: 30}, (_, index) => 1 + index).filter(item => Math.abs(quotaNumber - item) <= 10 || Math.abs(quotaNumber+30-item) <= 10)
    }

    const handleChangeQuota = (event) => {
        setDayNumber(event.target.value)
    }

    const handleClosedSnack = (event, reason) => {
        if(reason == 'clickaway'){
            return;
        }
        setIsSnackbar(false)
    }

    const validateQuotasPending = () => {
        let svd = 0;
        quotasPending?.forEach(quota => {
            if(quota.quotaNumber == 1) {
                svd += data[0]?.saldoCapital*0.00023;
            } else {
                svd += data[0]?.quotas.filter(item => item.quotaNumber == quota.quotaNumber-1)[0].projectionSaldoCapital*0.00023;
            }
        })
        return svd;
    }

    const handleChangeQuotas = (event) => {
        setNumberQuotas(event.target.value)
        console.log(event.target.value)
    }

    const updateQuotas = () => {
        if(data[0].quotas.filter(item => item.updatePayDate != null).length == 0) {
            setIsBackdrop(true)
            axiosClient.put(`/v1/quotas/update/${data[0].client.uuid}/${dayNumber}`)
            .then(res => {
                if (res.status === 200) {
                    setIsBackdrop(false);
                    setIsSnackbar(true);
                    setMessage("Se actualizaron exitosamente las fechas de pago de las cuotas");
                    setNewQuota(dayNumber);
                    setIsButton(false);
                } else {
                    setIsBackdrop(false);
                    setIsSnackbar(true);
                    setMessage("Error en la actualización de las fechas de pago de las cuotas");
                    setSeverity("error");
                }
            })
            .catch(error => {
                setIsBackdrop(false);
                setIsSnackbar(true);
                setMessage("Error en la actualización de las fechas de pago de las cuotas");
                setSeverity("error");
            });
        } else {
            setIsBackdrop(false)
            setIsSnackbar(true)
            setMessage("No se permite realizar la actualización de fechas de pago mas de una vez")
            setSeverity("error")
        }
    }

    useEffect(() => {
        if (localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }
        axiosClient.get(`/v1/quotas/client/${localStorage.getItem("clientUuid")}`)
        .then(response => {
            if (response.status === 200) {
                const res = response.data;
                console.log(res);
                setData(res);
                const approvedCredit = res?.find(item => item.status === "APPROVED");
                setBalanceCredit(approvedCredit?.balanceCredit ?? res?.[0]?.balanceCredit ?? 0);
                setClientName(res[0]?.client?.name || "");
                setClientLastName(res[0]?.client?.lastName || "");
                const resolvedOldId =
                    res[0]?.oldId ??
                    res[0]?.credit?.oldId ??
                    res[0]?.commerce?.oldId ??
                    null;
                setCreditOldId(
                    resolvedOldId !== null && resolvedOldId !== undefined
                        ? String(resolvedOldId)
                        : ""
                );
                setQuota(res.filter(item => item.status === "APPROVED")[0].quotas[0].payDate.split('T')[0]);
                setQuotasPending(res
                    .filter(item => item.status === "APPROVED")[0]
                    .quotas
                    .filter(item => new Date(item.payDate.split("T")[0]) < new Date() && item.status === "PENDING")
                );
            } else {
                alert("CommerceUuid Not Found");
            }
        })
        .catch(error => {
            console.log("Bad petition:" + error.message);
        });

        console.log(data)


    }, [newQuota]);

    useEffect(() => {
        axiosClient.get('/v1/parameters')
        .then(response => {
            if (response.status === 200) {
                setParameters(response.data);
            } else {
                console.log("Error with fetch");
            }
        })
        .catch(error => {
            console.log("Bad fetch " + error.message);
        });
    }, [])

    useEffect(() => {
        if(numberQuotas != null && numberQuotas != 0) {
            const creditBaseValue = balanceCredit || data[0]?.totalValue || data[0]?.saldoCapital || 0;
            const body = {
                creditValue: creditBaseValue,
                numberQuotas: numberQuotas,
                commerceId: data[0]?.commerce.oldId,
                tarifa: 0,
                svd: parameters.seguroVidaDeudor,
                interest: parameters.interestRate
            }
            axiosClient.post('/v1/quotas/valueOption', body)
            .then(response => {
                if (response.status === 200) {
                    setValue(response.data);
                } else {
                    console.log("Error with fetch");
                }
            })
            .catch(error => {
                console.log("Error fetch " + error.message);
            });
        }
    }, [numberQuotas])

   /* const handleUpdate = () => {
        if(value != null && value != 0) {
            if(!data.some(item => item.status != "APPROVED" && item.status != "REESTRUCTURADO")) {
                if(data.filter(item => item.status == "APPROVED")[0].reestructurado != true) {
                    setIsBackdrop(true)
                    const values = data.filter(item => item.status == "APPROVED")[0].balanceCredit
                    const body = {
                      creditUuid: data[0].uuid,
                      valorAcuerdoPago: value,
                      valorCreditoReestructurado: values,
                      quotasReestructurado: numberQuotas,
                      interestReestructurado: parameters.interestRate,
                      svdReestructurado: parameters.seguroVidaDeudor,
                      fgaReestructurado: 0,
                    };
                    axiosClient.post('/v1/credits/restructuring', body)
                    .then(response => {
                        if (response.status === 200) {
                            setIsModal(false);
                            setIsBackdrop(false);
                            setSeverity("success");
                            setIsSnackbar(true);
                            setMessage("Se ha reestructurado exitosamente el crédito");
                        } else {
                            setIsBackdrop(false);
                            setIsSnackbar(true);
                            setMessage("Error en la reestructuración del crédito");
                            setSeverity("error");
                            console.log("Error with fetch");
                        }
                    })
                    .catch(error => {
                        setIsBackdrop(false);
                        setIsSnackbar(true);
                        setMessage("Error en la reestructuración del crédito");
                        setSeverity("error");
                        console.log("Error fetch " + error.message);
                    });
                } else {
                        setIsBackdrop(false)
                        setIsSnackbar(true)
                        setMessage("No esta permitido reestructurar la reestructuración de otro crédito")
                        setSeverity("error")
                }
            } else {
                setIsBackdrop(false)
                            setIsSnackbar(true)
                            setMessage("Error en la reestructuración del crédito, ya hay una solicitud de reestructuración")
                            setSeverity("error")
            }
        }
    }*/

    const handleUpdate = () => {
      console.log("[handleUpdate] value:", value);
      console.log("[handleUpdate] data:", data);

      if (value != null && value != 0) {
        const itemsInvalidos = data.filter(
          (item) =>
            item.status != "COMPLETED" &&
            item.status != "REESTRUCTURADO" &&
            item.status != "AMPLIADO" &&
            item.status != "APPROVED",
        );
        console.log(
          "[handleUpdate] items con status no permitido:",
          itemsInvalidos,
        );

        if (itemsInvalidos.length === 0) {
          const approvedItem = data.filter(
            (item) => item.status == "APPROVED",
          )[0];
          console.log("[handleUpdate] approvedItem:", approvedItem);
          console.log(
            "[handleUpdate] reestructurado flag:",
            approvedItem?.reestructurado,
          );

          if (approvedItem.reestructurado != true) {
            setIsBackdrop(true);
            const values = approvedItem.balanceCredit;
            const body = {
              creditUuid: data[0].uuid,
              valorAcuerdoPago: value,
              valorCreditoReestructurado: values,
              quotasReestructurado: numberQuotas,
              interestReestructurado: parameters.interestRate,
              svdReestructurado: parameters.seguroVidaDeudor,
              fgaReestructurado: 0,
            };
            console.log("[handleUpdate] body a enviar:", body);

            axiosClient
              .post("/v1/credits/restructuring", body)
              .then((response) => {
                if (response.status === 200) {
                  setIsModal(false);
                  setIsBackdrop(false);
                  setSeverity("success");
                  setIsSnackbar(true);
                  setMessage("Se ha reestructurado exitosamente el crédito");
                } else {
                  setIsBackdrop(false);
                  setIsSnackbar(true);
                  setMessage("Error en la reestructuración del crédito");
                  setSeverity("error");
                  console.log("Error with fetch");
                }
              })
              .catch((error) => {
                setIsBackdrop(false);
                setIsSnackbar(true);
                setMessage("Error en la reestructuración del crédito");
                setSeverity("error");
                console.log("Error fetch " + error.message);
              });
          } else {
            console.log(
              "[handleUpdate] Bloqueado: el crédito APPROVED ya tiene reestructurado = true",
            );
            setIsBackdrop(false);
            setIsSnackbar(true);
            setMessage(
              "No esta permitido reestructurar la reestructuración de otro crédito",
            );
            setSeverity("error");
          }
        } else {
          console.log(
            "[handleUpdate] Bloqueado: hay items con status no permitido ->",
            itemsInvalidos.map((i) => ({ uuid: i.uuid, status: i.status })),
          );
          setIsBackdrop(false);
          setIsSnackbar(true);
          setMessage(
            "Error en la reestructuración del crédito, ya hay una solicitud de reestructuración",
          );
          setSeverity("error");
        }
      } else {
        console.log("[handleUpdate] Bloqueado: value inválido ->", value);
        setIsBackdrop(false);
        setIsSnackbar(true);
        setMessage(
          "Error en la reestructuración del crédito, ya hay una solicitud de reestructuración",
        );
        setSeverity("error");
      }
    };

    return (
        <React.Fragment>
            {/* <Box sx={{ display: 'flex' }}> */}
                <CssBaseline />
                {/* <Header position="fixed" /> */}
                {/* <SideDrawer></SideDrawer> */}
                <br /><br />
                <Toolbar />
                <Box sx={{ width: '100%' }}>
                    <Stack spacing={2}>
                        <Item>.</Item>
                        <Item>.</Item>
                        {/* first line */}
                        <Grid container spacing={2} width={'100%'} alignItems={'center'}>
                            <Grid item xs={6}>
                                <Box sx={{textAlign: 'left'}}>
                                    {clientName ? (
                                        <h2 style={{margin: 0}}>Nombre: {clientName}</h2>
                                    ) : null}
                                    {clientLastName ? (
                                        <h2 style={{margin: 0}}>Apellido: {clientLastName}</h2>
                                    ) : null}
                                    {creditOldId ? (
                                        <h4 style={{margin: '8px 0 0 0'}}>Old ID crédito: {creditOldId}</h4>
                                    ) : null}
                                </Box>
                            </Grid>
                            <Grid item>
                                <ButtonPrincipal onClick={handleModal}>Reestructurar</ButtonPrincipal>
                            </Grid>
                            <Grid item>
                                <ButtonPrincipal onClick={handleButton}>Fecha de pago</ButtonPrincipal>
                            </Grid>
                        </Grid>
                        {/* second line */}
                        <Grid container spacing={2} width={'100%'}>
                            <TableContainer component={Paper} >
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Saldo Inicial</TableCell>
                                            <TableCell align="center">Total amortizado</TableCell>
                                            <TableCell align="center">Total Intereses</TableCell>
                                            <TableCell align="center">Saldo Capital</TableCell>
                                            <TableCell align="center">Tasa de Interes</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((row) => (
                                            <TableRow key={row.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="center">{formatter.format(row.totalValue)}</TableCell>
                                                <TableCell align="center">{formatter.format(row.totalAmortizado)}</TableCell>
                                                <TableCell align="center">{formatter.format(row.totalInteresesPagados)}</TableCell>
                                                <TableCell align="center" >{formatter.format(row.saldoCapital)}</TableCell>
                                                <TableCell align="center">{row.interestRate}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                        <br />
                        <Grid container spacing={2} width={'100%'}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center"># Cuota</TableCell>
                                            <TableCell align="center">Fecha de pago</TableCell>
                                            <TableCell align="center">Valor Cuota</TableCell>
                                            <TableCell align="center">Valor Pagado</TableCell>
                                            <TableCell align="center">Intereses</TableCell>
                                            <TableCell align="center">Amortización</TableCell>
                                            <TableCell align="center">Saldo Final</TableCell>
                                            <TableCell align="center">Status</TableCell>
                                            <TableCell align="center">Notas</TableCell>
                                            <TableCell align="center">Soporte de Pago</TableCell>

                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((row) => (
                                            row.quotas.map((quota) => (
                                                <TableRow key={quota.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell align="center">{quota.quotaNumber}</TableCell>
                                                    <TableCell align="center" >{dateFormater((quota.paidDate) == null ? quota.payDate : quota.paidDate)}</TableCell>
                                                    <TableCell align="center">{formatter.format(quota.value)}</TableCell>
                                                    <TableCell align="center">{formatter.format(quota.paidValue)}</TableCell>
                                                    <TableCell align="center" >{formatter.format(quota.interesesPagados)}</TableCell>
                                                    <TableCell align="center" >{formatter.format(quota.amortizacion)}</TableCell>
                                                    <TableCell align="center">{formatter.format(quota.saldoCapital)}</TableCell>
                                                    <TableCell align="center" >
                                                        {render(quota.status)}
                                                    </TableCell>
                                                    <TableCell align="center">{quota.comments}</TableCell>
                                                    <TableCell align="center">Ver</TableCell>

                                                </TableRow>
                                            ))
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Stack>
                </Box>
                {isModal ? 
                    <Modal activeModal={isModal} handleModal={handleModal}>
                        <Box sx={{width: '80%', margin: 'auto', textAlign: 'center'}}>
                            <h2>Reestructuración de créditos</h2>
                            <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='center'>Variable</TableCell>
                                        <TableCell align='center'>Valor</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell align='center'>Deuda total</TableCell>
                                        <TableCell align='center'>{formatter.format(balanceCredit || 0)}
                                            </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align='center'>Número de cuotas</TableCell>
                                        <TableCell align='center'>
                                            <FormControl fullWidth>
                                                <Select labelId="number-quota" id="numberQuota" label="Número de cuotas" variant='outlined' value={numberQuotas} onChange={handleChangeQuotas}>
                                                {quotas.map(quota => (
                                                    <MenuItem key={quota} value={quota}>{quota}</MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align='center'>Nuevo valor cuota</TableCell>
                                        <TableCell align='center'>{formatter.format(value, 0)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                            <Box mt={5} mb={8}>
                                <ButtonPrincipal onClick={handleUpdate}>Reestructurar</ButtonPrincipal>
                            </Box>
                        </Box>
                    </Modal>
                : null}

                {isButton ?
                    <Modal activeModal={isButton} handleModal={handleButton}>
                        <Box sx={{width: '50%', margin: 'auto', textAlign: 'center'}}>
                            <h2>Fecha de pago</h2>
                            <Box sx={{padding: '1.5rem'}}>
                                <form>
                                    <Box mt={5} mb={2}>
                                        <FormControl fullWidth sx={{textAlign: 'start'}}>
                                            <TextField id='quota-page' label='Dia de pago actual del crédito' value={quota.split("-")[2]} disabled></TextField>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5}>
                                        <FormControl fullWidth>
                                            <InputLabel id="quota">Día de pago</InputLabel>
                                            <Select labelId="quota" id="quotaNew" label="Día de pago" value={dayNumber} onChange={handleChangeQuota}>
                                                {generateQuotas(parseInt(quota.split("-")[2])).map(quota => (
                                                    <MenuItem key={quota} value={quota}>{quota}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box mt={5} mb={8}>
                                        <ButtonPrincipal onClick={updateQuotas}>Actualizar</ButtonPrincipal>
                                    </Box>
                                </form>
                            </Box>
                        </Box>
                    </Modal>
            : null}
            {/* </Box> */}
            <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={isBackdrop}>
                <CircularProgress color="success" />
            </Backdrop>
            <Snackbar open={isSnackbar} autoHideDuration={5000} onClose={handleClosedSnack}>
                <Alert onClose={handleClosedSnack} severity={severity} sx={{width: '100%'}}>{message}</Alert>
            </Snackbar>
        </React.Fragment >
    );
}